"use client";
import Script from "next/script";

// NOTE: Copied this paradigm from the Google Tag Manager code in @next/third-parties.
interface MetaPixelParams {
  pixelId: string;
  nonce?: string;
}

export default function MetaPixel({ pixelId, nonce }: MetaPixelParams) {
  return (
    <div>
      <Script
        id="_next-meta-pixel-init"
        // biome-ignore lint/security/noDangerouslySetInnerHtml: unfortunately only way to do this
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${pixelId}');
            fbq('track', 'PageView');
          `,
        }}
        nonce={nonce}
      />
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </div>
  );
}

// Currently not used, but keeping it here for now in case we get a request for it later.
export const sendMetaPixelEvent = (
  eventName: string,
  // biome-ignore lint/suspicious/noExplicitAny: this can literally be anything.
  params?: Record<string, any>,
) => {
  if (typeof window === "undefined") return;

  // Define fbq if it doesn't exist (fallback)
  if (!window.fbq) {
    // biome-ignore lint/suspicious/noExplicitAny: this can literally be anything.
    window.fbq = (...args: any[]) => {
      window.fbq.queue.push(args);
    };
    window.fbq.queue = [];
  }

  if (params) {
    window.fbq("track", eventName, params);
  } else {
    window.fbq("track", eventName);
  }
};
